<template>
  <div class="footer">
    <div class="footer-top w1200">
      <div class="footer-img" style="display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;">
        <router-link to="/">
          <img src="../assets/img/logo_bottom.png" class="footer-logo" alt="">
        </router-link>

        <!-- <span class="dh" style="color: #fff; font-family: '微软雅黑';">联系电话：+8657188278888</span>
  <span class="dh" style="color: #fff; margin: 10px 0; font-family: '微软雅黑';">中国 • 杭州市上城区五星路65号</span>
  <span class="dh" style="color: #fff; font-family: '微软雅黑';">邮编：312000</span>
 -->

      </div>
      <div class="footer-list cur-pointer" v-for="(item, index) in navs" :key="index" @click="goPage(item)">{{ item.name }}
      </div>

    </div>
    <div class="footer-bottom w1200">
      <div class="footer-info">
        Copyright © 2023 久泰酒店管理有限公司杭州久泰饭店 www.zhongkehotels.com All Rights Reserved
        <br /><a href="https://beian.miit.gov.cn" target="_blank">浙ICP备2023013620号-1</a>
        <!-- <a href="http://www.beian.miit.gov.cn" target="_blank">公安机关备案号：11011302000273</a> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data () {
    return {
      navs: []
    };
  },
  mounted () {
    this.getMenu();
  },
  methods: {
    //底部导航
    getMenu () {
      let self = this;
      this.$axios
        .get(`/api/portal/navMenu/menu?lang=${this.$i18n.locale}&nav=footer`)
        .then(function (res) {
          Object.keys(res.data.data).forEach(function (key) {
            res.data.data[key].showChild = false;
          });
          self.navs = res.data.data;
        });
    },
    //子项切换
    ToggleChild (item) {
      item.showChild = !item.showChild;
    }
    ,
    goPage (item) {
      console.log(item, 666999);
      if (item.name.indexOf('电话：') > -1) {
        console.log(item.name.substr(item.name.indexOf('电话：') + 3));
        window.location.href = 'tel://' + item.name.substr(item.name.indexOf('电话：') + 3)
        return
      }
      if (item.name.indexOf('TEL：') > -1) {
        console.log(item.name.substr(item.name.indexOf('TEL：') + 4));
        window.location.href = 'tel://' + item.name.substr(item.name.indexOf('TEL：') + 4)
        return
      }
      // if(item.id=='99'){
      //   this.$router.push("/detail?id=" + 193);
      // }
      this.showSearch = false;
      this.showNavs = false;
      if (item.href.indexOf("http") > -1) {
        window.location.href = item.href;
        return;
      }
      let id = item.href.substr(-2);
      console.log(item, id);
      id = id.replace("=", "");
      let name = item.name;
      if (item.name == "首页" || item.name == "Home") {
        this.$router.push("/");
        return;
      }
      // if(isNaN(id)){
      //   return
      // }
      console.log(id, item.name);
      let self = this;

      if (item.lcj_type == "category") {
        let cates = document.getElementById('cates');
        cates.scrollIntoView(true);
        document.body.scrollTop = document.documentElement.scrollTop = cates.offsetTop - 90
        // this.$axios
        // .get(`/api/portal/categories/${id}&lang=${this.$i18n.locale}`)
        // .then(function(res) {
        //   console.log(res);
        // if(res.data.data.type == 'file'){
        // self.$router.push(`/tabledownload?id=${id}&name=${name}`);
        // }else{
        //     self.$router.push(`/news?id=${id}&name=${name}`);
        // }
        // });
        this.$EventBus.$emit('goNav', id)
      } else if (item.lcj_type == "extra_page") {
        this.$router.push("/");
        let solution = document.getElementById('solution')
        solution.scrollIntoView(true)

        document.body.scrollTop = document.documentElement.scrollTop = solution.offsetTop - 90

      } else {

        if (this.$i18n.locale == 'cn') {
          this.$router.push("/detail?id=" + 57);
          if (item.id == '4') {
            this.$router.push("/detail?id=" + 77);
          }
        } else {
          this.$router.push("/detail?id=" + 193);
          if (item.id == '97') {
            this.$router.push("/detail?id=" + 158);
          }
        }
      }

    },
  },
  watch: {
    "$i18n.locale" () {
      this.getMenu();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.footer {
  background: #802628;

  .footer-phone {
    width: 110px;
    vertical-align: super;
    margin-left: 10px;
  }

  .footer-top {
    padding: 15px 16px;
    display: flex;
    justify-content: center !important;
    flex-direction: column !important;
    align-items: center !important;

    .footer-title {
      font-size: 20px;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      line-height: 33px;
      margin-bottom: 16px;
    }

    .footer-list {

      margin-bottom: 24px;
      font-size: 18px;
      font-family: "微软雅黑";
      font-weight: 400;
      color: #FFFFFF;
      line-height: 25px;
    }

    .footer-title-phone {
      display: none;
    }

    .footer-list-phone {
      display: none;
    }
  }

  .footer-bottom {
    width: 100%;
    border-top: 1px solid #FFFFFF;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 50px;

    .footer-info {

      text-align: center;
      word-break: break-word;

      br {
        display: none;
      }
    }
  }
}

.footer-img {
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.footer-logo {
  width: 210px;
}

@media (max-width: 768px) {
  .footer-img {
    margin-bottom: 15px;

  }

  .footer-logo {
    width: 200px;
  }

  .footer-phone {
    width: 110px;
    vertical-align: super;
    margin-left: 10px;
  }

  .footer {
    padding: 32px 16px 0px 16px;

    .footer-top {
      padding: 0px;

      .footer-list {

        margin-bottom: 24px;

        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 20px;
      }

      .footer-title-phone {
        display: block;
        font-size: 20px;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
        line-height: 33px;
        padding: 16px;
        border-top: 2px solid rgba(255, 255, 255, 0.14);
        position: relative;
        text-align: left;

        img {
          position: absolute;
          right: 16px;
          top: 50%;
          transform: translateY(-50%);
        }
      }

      .footer-list-phone {
        padding-left: 16px;
        display: block;
        font-size: 14px;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.8);
        line-height: 34px;
      }
    }

    .footer-bottom {
      text-align: left;
      padding: 12px 0px;
      font-size: 13px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 18px;

      .footer-imgs {

        img {
          margin-left: 0px;
        }
      }

      .footer-info {
        text-align: left;

        br {
          display: block;
        }
      }
    }
  }
}
</style>
